<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("RESELLER_PRODUCTS.EDIT_RESELLER_PRODUCT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <reseller-product-form
              :loading="loading"
              :resellerProductData="resellerProduct"
              :formErrors="formErrors"
              @resellerProductSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ResellerProductForm from "./partials/ResellerProductForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerProduct from "./defaultResellerProduct";

export default {
  layout: "DashboardLayout",

  components: { ResellerProductForm },

  mixins: [alertLeave],

  data() {
    return {
      resellerProduct: cloneDeep(defaultResellerProduct),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("resellerProducts/get", id);
        this.resellerProduct =
          this.$store.getters["resellerProducts/resellerProduct"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List ResellerProducts" });
    },

    viewResellerProduct() {
      this.alertLeave = false;
      this.$router.push({
        name: "View ResellerProduct",
        params: { id: this.resellerProduct.id },
      });
    },

    async handleSubmit(resellerProduct) {
      this.loading = true;
      const resellerProductData = cloneDeep(resellerProduct);

      try {
        await this.$store.dispatch(
          "resellerProducts/update",
          resellerProductData
        );
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_PRODUCTS.RESELLER_PRODUCT_UPDATED"),
        });
        this.viewResellerProduct();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
